<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col xs:w-full sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4 glow">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col grey-bg xs:w-full lg:w-1/2 xl:w-1/2 ">
              <div style="height: 288px;" >
                <span class="helper"></span>
                <img src="@/assets/images/pages/login.png"
                  alt="login"
                  class="mx-auto" />
              </div>
            </div>

            <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Mot de passe oublié</h4>
                  <p v-if="!showPassCheck">Veuillez saisir votre adresse mail.</p>
                  <p v-else>Veuillez saisir le code de vérification reçu par mail.</p>
                </div>

                <div>
                  <vs-input
                    v-show="!showPassCheck"
                    name="email"
                    type="text"
                    icon-no-border
                    icon="icon icon-user"
                    icon-pack="feather"
                    label-placeholder="Email"
                    v-model="email"
                    class="w-full"
                  />

                  <vs-input
                    v-show="showPassCheck"
                    type="text"
                    name="password"
                    icon-no-border
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="Code de vérification"
                    v-model="passCheck"
                    class="w-full mt-6"
                  />
                  <vs-button
                    color="primary"
                    v-if="!showPassCheck"
                    class="float-right login-btn"
                    @click="sendPassResetRequest"
                  >Envoyer la demande</vs-button
                  >
                  <vs-button
                    color="primary"
                    v-if="showPassCheck"
                    class="float-right login-btn"
                    @click="checkPasscode"
                  >Vérifier le code</vs-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
// import bcrypt from 'bcrypt'

export default {
	name: "forgotten-password",
	data() {
		return {
			email: "",
			apiUrl: this.$store.state.backendApiUrl,
			hasError: false,
			error_msg: "",
			passCheck: "",
			showPassCheck: false,
		};
	},
	methods: {
		/**
		 * Query API to login or not the user
		 */
		sendPassResetRequest() {
			if(this.email == ""){
				this.$vs.notify({
					title: "Erreur",
					text: "Remplissez tout les champs pour vous connecter",
					color: "danger"
				});
			}
			else{
				this.showPassCheck = true;
				this.$http
					.post(this.apiUrl + "mail/sendPassResetRequest", {
						email: this.email,
					})
					.then(response => {
						//console.log(response);
					})
					.catch(err => {
						this.$vs.notify({
							title: "Erreur",
							text: "La demande a échoué",
							color: "danger"
						});
						console.error(err);
					});
			}
		},

		checkPasscode(){
			if(this.passCheck && this.email){
				this.$http
					.post(this.apiUrl + "mail/checkPasscode", {
						email: this.email,
						check: this.passCheck
					})
					.then(response => {
						//console.log(response);
						if(response){
							this.$vs.notify({
								title: "Succès",
								text: "Votre demande a été prise en compte.",
								color: "success"
							});
							this.$router.go(-1);
						}
						else{
							//console.log("code not ok...", response);
							this.$vs.notify({
								title: "Erreur",
								text: "La demande a échoué",
								color: "danger"
							});
						}
					})
					.catch(err => {
						this.$vs.notify({
							title: "Erreur",
							text: "La demande a échoué",
							color: "danger"
						});
						console.error(err);
					});
			}
			// const codeOk = bcrypt.compareSync(this.email, this.passCheck)

		}
	}
};
</script>

<style lang="scss">
#page-login {
  .hidden-btn {
    visibility: hidden;
  }
  .login-btn {
    margin-top: 10px;
  }
  .grey-bg{
    background-color: #f8f8f8;
    width: 100%;
  }
  .helper {
    display: inline-block;
    height: 30%;
    vertical-align: middle;
  }
  .glow{
    box-shadow: 0px 0px 15px 5px rgba(7, 237, 230, 0.82);
  }
  img {
    vertical-align: middle;
  }
}
.layout--full-page .full-page-bg-color{
  background-color: #FFF;
}
</style>
